module.exports = __webpack_public_path__ + "static/img/other_type.738a78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oneMachine/other_type.png
// module id = Zvhh
// module chunks = 0